export var CraftingCategory;
(function (CraftingCategory) {
    CraftingCategory[CraftingCategory["Weapon"] = 0] = "Weapon";
    CraftingCategory[CraftingCategory["Shield"] = 1] = "Shield";
    CraftingCategory[CraftingCategory["Engine"] = 2] = "Engine";
    CraftingCategory[CraftingCategory["Module"] = 3] = "Module";
    CraftingCategory[CraftingCategory["Consumable"] = 4] = "Consumable";
})(CraftingCategory || (CraftingCategory = {}));
//# sourceMappingURL=crafting.js.map